<template>
    <with-dimensions>
        <table-ish slot-scope="{ width }">
            <table-ish-row-router-link
                v-for="listing in listings"
                :key="listing.uuid"
                :to="{
                    name: $router.fix('dashboard.*.listings.show'),
                    params: {
                        listing: listing.uuid
                    }
                }"
            >
                <table-ish-cell>
                    <slot
                        name="primary"
                        :listing="listing"
                    />

                    <truncate-hack slot="secondary">
                        {{ listing.number_of_bedrooms }} bed {{ listing.property_type }}
                    </truncate-hack>
                </table-ish-cell>

                <table-ish-cell
                    :shrink="true"
                    class="text-right"
                >
                    <span
                        :class="[
                            activeStateCss(listing.is_active),
                            width > 500 ? 'text-sm px-3 py-1' : 'text-xs px-2'
                        ]"
                        class="font-semibold rounded-full"
                    >
                        {{ listing.is_active ? 'Active' : 'Draft' }}
                    </span>
                </table-ish-cell>
            </table-ish-row-router-link>
        </table-ish>
    </with-dimensions>
</template>

<script>
    import StateCssMixin from '../mixins/state-css'

    export default {
        mixins: [
            StateCssMixin
        ],
        props: {
            listings: {
                type: Array,
                required: true
            }
        },
        methods: {
        }
    }
</script>
